<template>
  <HiddenDownloadForm ref="downloadForm" />
  <TableSpinner :loading="pageLoading">
    <h4 >Все авторизации</h4>
    <div :class="$style.downloadButtonContainer">
      <el-button text class="text-button" :class="$style.downloadButton" @click="exportReportData" style="height: auto !important">
        <font-awesome-icon icon="external-link-alt"/>&nbsp;Экспортировать CSV файл
      </el-button>
    </div>
  
    <el-table :data="allAuths" style="width: 100%" >
      <el-table-column prop="user_id" label="Пользователь" min-width="120" />
      <el-table-column :formatter="userFio" label="Имя" min-width="180" />
      <el-table-column prop="type" label="Тип" />
      <el-table-column prop="ip" label="IP-адрес"  min-width="180" />
      <el-table-column :formatter="authStatus" min-width="120" label="Статус" />
      <el-table-column label="Данные" min-width="150" >
        <template #default="scope">
          {{scope.row.browser}}<br/> {{scope.row.os}}
        </template>
      </el-table-column>
      <el-table-column :formatter="formatDate" fixed="right" label="Дата"  min-width="100" />
    </el-table>
    <div class="solo-pagination-container">
      <el-pagination
          background
          class="wide-page-size"
          layout="sizes, prev, pager, next"
          :total="totalAuths"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :hide-on-single-page="true"
          :pager-count="3"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
      >
      </el-pagination>
    </div>
  </TableSpinner>
</template>

<script>
import HiddenDownloadForm from "@shared/components/layout/download-form.component"
import moment from "moment"

export default {
  name: "AuthorizationsTable",
  components: {HiddenDownloadForm},
  props: ["allAuths", "totalAuths", "subusers", "reportParams", "downloadUrl", "pageLoading"],
  methods: {
    formatDate(row){
      return moment(row.date).utcOffset(this.$store.getters.user.utcOffset || 0).format("DD.MM.YYYY HH:mm:ss")
    },
    userFio(row){
      let subuser = this.subusers.find(s => s.system_id === row.user_id)
      if(!subuser) return ""
      return `${subuser.info.lastname} ${subuser.info.firstname} ${subuser.info.patronymic}`
    },
    authStatus(row){
      return String(row.result) === '1' ? 'Успешно' : 'Ошибка'
    },
    handlePageSizeChange(newSize){
      this.$emit("paginationChanged", {size: newSize})
    },
    handleCurrentPageChange(newPage){
      if (this.allAuths.length){this.$emit("paginationChanged", {page: newPage})}
    },
    exportReportData(){
      let url = `${this.axios.defaults.baseURL}${this.downloadUrl}`
      let params = this.reportParams
      this.$refs.downloadForm.download(url, params)
    }
  }
}
</script>

<style lang="css" module>
.downloadButtonContainer{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.downloadButton{
  padding: 0px;
  min-height: auto;
}
</style>